import { LogLevel } from "@azure/msal-browser";

const isLocalEnvironment = window.location.hostname === 'localhost';
const redirectUri = isLocalEnvironment 
    ? process.env.REACT_APP_AZURE_REDIRECT_URI_LOCAL 
    : process.env.REACT_APP_AZURE_REDIRECT_URI;

console.log('🌐 Environnement:', isLocalEnvironment ? 'Local' : 'Production');
console.log('🔗 URI de redirection:', redirectUri);

export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
        redirectUri: redirectUri
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: true,
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) {
            return;
          }
          if (level === LogLevel.Error) {
            console.error(`[MSAL] ${message}`);
            return;
          }
          if (level === LogLevel.Warning) {
            console.warn(`[MSAL] ${message}`);
          }
        },
        piiLoggingEnabled: false,
        logLevel: LogLevel.Warning,
      },
    },
  };

export const loginRequest = {
  scopes: [
    'User.Read',
    'profile',
    'offline_access',
    'email',
    'api://c247d402-5b9d-40f2-b7e6-b15a47c56f22/Api.access' // Ajout du scope pour les rôles
  ]
};

export const tokenRequest = {
  scopes: [
    "api://c247d402-5b9d-40f2-b7e6-b15a47c56f22/myscope",
    'User.Read',
    'Api.access',
    'api://c247d402-5b9d-40f2-b7e6-b15a47c56f22/Api.access' // Ajout du scope pour les rôles
  ]
};